import { create } from "zustand";

export type HZoomStore = {
    zoomFactor: number;
    setZoomFactor: (zoomFactor: number) => void;
}

export const useZoomStore = create<HZoomStore>((set) => ({
    zoomFactor: 1,
    setZoomFactor: (zoomFactor) => set({ zoomFactor }),
}));

export const useZoomFactor = () => {
    return useZoomStore((state) => state.zoomFactor);
}